export const Footer = () => {
  return (
    <footer className="border-t border-border bg-card/50 backdrop-blur-sm mt-auto">
      <div className="container mx-auto px-4 py-8 max-w-7xl">
        <div className="flex flex-col items-center gap-6">
          {/* Professional Credits */}
          <div className="flex flex-col md:flex-row items-center gap-4 text-center md:text-left">
            <div className="flex flex-col items-center md:items-start">
              <span className="text-xs uppercase tracking-wider text-muted-foreground mb-1">
                Developed by
              </span>
              <span className="text-lg font-semibold text-foreground">
                Shafi Tareen
              </span>
            </div>
            
            <div className="hidden md:block w-px h-12 bg-border"></div>
            
            <div className="flex flex-col items-center md:items-start">
              <span className="text-xs uppercase tracking-wider text-muted-foreground mb-1">
                Technical Review
              </span>
              <span className="text-lg font-semibold text-foreground">
                Nasir Khan
              </span>
            </div>
          </div>
          
          {/* Additional Info */}
          <div className="text-center text-sm text-muted-foreground">
            <p>Privacy-first image analysis • No data retention • Client-side processing</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
